import React, { useState, useContext, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSearchParams } from 'react-router-dom';
import { contentContext } from "../../context/contentContext";
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { ToastContainer, toast, CloseButton } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TableLoader from "../../components/tableLoader";
import DataTable from 'react-data-table-component';
import moment from "moment";

let { lambda, appname } = window.app;

// Hook to track previous route
function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

const Theme = () => {
  const location = useLocation();
  const route = location.pathname;
  const prevRoute = usePrevious(route);

  const {
    userData,
    rowsPerPage,
    setRowsPerPage,
    currentPageNew,
    setCurrentPage,
    setSearchedFlag,
    setUserSearch,
    // <-- assume this exists in context
  } = useContext(contentContext);
  const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "Visitor App Settings")
  const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
  const [image, setImg] = useState('');
  const [specialDays, setSpecialDays] = useState([]);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isListView, setIsListView] = useState(true);
  const [selectedButton, setSelectedButton] = useState("Default");
  const [show, setShow] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [editData, setEditData] = useState({});
  const [isDelete, setIsDelete] = useState(false)
  const [deleteLoader, setDeleteLoader] = useState(false)
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [form, setForm] = useState({
    dayTitle: "",
    fromDate: "",
    toDate: "",
    status: "",
    theme: "Default"
  });

  const useruniqueid = localStorage.getItem("userId");

  useEffect(() => {
    if (editData) {
      setForm({
        dayTitle: editData.dayTitle || '',
        fromDate: editData.fromDate?.substring(0, 10) || '', // format as yyyy-mm-dd
        toDate: editData.toDate?.substring(0, 10) || '',
        status: editData.status || ''
      });
    }
  }, [editData]);

  useEffect(() => {
    if (prevRoute !== undefined && prevRoute !== route) {
      setCurrentPage(1);
      setRowsPerPage(15);
      setSearchedFlag(false);
      setUserSearch("");
    }
  }, [prevRoute]);

  useEffect(() => {
    if (!window.site) {
      setTimeout(() => {
        if (window.site?.common?.imageCloudfront) {
          setImg(window.site.common.imageCloudfront);
        }
      }, 1000);
    } else {
      setImg(window.site?.common?.imageCloudfront || '');
    }

    if (id) {
      setIsEditMode(true);           // Enable edit mode
      setIsListView(false);          // Switch view
      fetchSpecialDays(id);          // Fetch with id
    } else {
      setIsEditMode(false);          // Normal view
      fetchSpecialDays();            // Fetch all
    }
  }, [id]); // 👈 dependency on `id` is important


  const fetchSpecialDays = async (themeId) => {
    try {
      setIsLoading(true);
      const res = await axios.get(`${lambda}getTheme?appname=${appname}${themeId ? `&themeId=${themeId}` : ''}`);

      let result;
      if (themeId) {
        result = res.data.result.data[0]
      } else {
        result = res.data.result.data
      }


      if (themeId) {
        // Edit mode
        setSpecialDays([result]);
        setData([result]);
        setForm({
          dayTitle: result.dayTitle || '',
          fromDate: result?.fromDate?.substring(0, 10) || '',
          toDate: result?.toDate?.substring(0, 10) || '',
          status: result.status || '',
          theme: result.theme || "Default"
        });
        setSelectedButton(result.theme || "Default");
      } else {
        // List mode
        setSpecialDays(result || []);
        setData(result || []);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Failed to fetch special days.");
      setSpecialDays([]);
      setData([]);
    } finally {
      setIsLoading(false);
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSave = async () => {
    let errors = {};

    if (!form.dayTitle) errors.dayTitle = "Day title is required";
    if (!form.fromDate) errors.fromDate = "Start date is required";
    if (!form.toDate) errors.toDate = "End date is required";
    if (form.fromDate && form.toDate && new Date(form.fromDate) > new Date(form.toDate)) {
      errors.toDate = "End date must be after start date";
    }
    if (!form.status) errors.status = "Status is required";

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setBtnLoader(true);
    const payload = {
      createdBy: {
        name: userData?.name,
        userid: useruniqueid,
      },
      dayTitle: form?.dayTitle,
      fromDate: form?.fromDate,
      toDate: form?.toDate,
      status: form?.status?.toUpperCase(),
      theme: form?.theme,
    };

    try {
      if (isEditMode && editId) {
        await axios.post(`${lambda}editTheme?appname=${appname}&themeId=${editId}`, payload);
        //toast.success("Theme updated successfully");
        toast.success("Theme updated successfully", {
          onClose: () => {
            setForm({ dayTitle: "", fromDate: "", toDate: "", status: "", theme: "Default" });
            setSelectedButton("Default");
            setIsEditMode(false);
            setEditId(null);
            setFormErrors({});
            setIsListView(true);
            navigate("/visitorappsettings");
            fetchSpecialDays();
          }
        });

      } else {
        await axios.post(`${lambda}addTheme?appname=${appname}`, payload)
        //toast.success("Theme created successfully");
        toast.success("Theme created successfully", {
          onClose: () => {
            setForm({ dayTitle: "", fromDate: "", toDate: "", status: "", theme: "Default" });
            setSelectedButton("Default");
            setIsEditMode(false);
            setEditId(null);
            setFormErrors({});
            setIsListView(true);
            navigate("/visitorappsettings");
            fetchSpecialDays();
          }
        });
      }
    } catch (error) {
      console.error("Save error:", error);
      toast.error("Something went wrong while saving.");
    } finally {
      setBtnLoader(false);
    }

  };

  const handleEdit = (day) => {
    console.log("day", day)
    // setForm({
    //   dayTitle: day.dayTitle,
    //   fromDate: day?.fromDate?.substring(0, 10) || '',
    //   toDate: day?.toDate?.substring(0, 10) || '',
    //   status: day.status,
    //   theme: day.theme || "Default"
    // });
    // setSelectedButton(day.theme || "Default");
    navigate(`/visitorappsettings/?id=${day.themeId}`);
    setEditId(day.themeId);
    // fetchSpecialDays(day.themeId);
    // setIsEditMode(true);
    // setIsListView(false);
  };
  const handleDelete = (id) => {
    setIsDelete(true)
    setEditId(id)
  }
  const handleClose = () => {
    setIsDelete(false)
  }
  const handleDeleteTheme = async () => {
    setDeleteLoader(true);
    try {
      const payload = { status: "ARCHIVE" };

      if (editId) {
        await axios.post(`${lambda}editTheme?appname=${appname}&themeId=${editId}`, payload);
        toast.success("Theme deleted successfully", {
          onClose: () => {
            setForm({ dayTitle: "", fromDate: "", toDate: "", status: "", theme: "Default" });
            setSelectedButton("Default");
            setIsEditMode(false);
            setEditId(null);
            setFormErrors({});
            setIsListView(true);
            navigate("/visitorappsettings");
            fetchSpecialDays();
            setDeleteLoader(false);
          }
        });
      }

      setIsDelete(false); // ✅ Close modal after delete

    } catch (error) {
      console.error("Save error:", error);
      toast.error("Something went wrong while saving.");
    } finally {
      setBtnLoader(false);
      setDeleteLoader(false);
    }
  };


  const handleCancel = () => {
    setIsDelete(false)
  }

  const toggleView = () => {
    setIsListView(!isListView);

    if (!isListView) {
      setForm({ dayTitle: "", fromDate: "", toDate: "", status: "", theme: "Default" });
      setSelectedButton("Default");
      setIsEditMode(false);
      setEditId(null);
      setFormErrors({});

      // Remove the ?id=... from URL
      navigate("/visitorappsettings");
    }
  };

  const handleClick = () => setShow(true);
  const handleSet = () => { setForm((prev) => ({ ...prev, theme: selectedButton })); setShow(false); };
  const handleButtonClick = (value) => setSelectedButton(value);

  const getThemeImage = (theme) => {
    switch (theme) {
      case "Sunset Red": return "MapView-2.png";
      case "Ocean Blue": return "MapView-3.png";
      case "Calm Forest": return "MapView-4.png";
      case "Fire Red": return "MapView-5.png";
      case "Christmas": return "christmas.jpg";
      case "Halloween": return "halloween.jpg";
      case "New Year": return "newyear.jpg";
      case "Independence day": return "independenceday.jpg";
      default: return "MapView-1.png";
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage) => {
    setRowsPerPage(newPerPage);
  };

  const customNoRecords = () => {
    return (

      <div className="empty-state-body empty-record"  >
        <div className="empty-state__message">
          <span className="material-icons">summarize</span>
          <p className="form-check font-size-16">No themes found. </p>
        </div> </div>
    )
  }

  const keyForRerender = `${rowsPerPage}_${data?.length}`;

  const columns = [
    {
      name: 'Name',
      cell: row => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {row?.theme && (
            <img
              src={`${image}${appname}/theme/${getThemeImage(row.theme)}`}
              alt={row.theme}
              style={{ width: '20px', height: 'auto', borderRadius: '3px' }}
            />
          )}
          <span>{row?.dayTitle || '—'}</span>
        </div>
      ),
      selector: row => row?.dayTitle ?? '',
      sortable: true,
    },
    {
      name: 'Theme',
      selector: row => row?.theme ?? "",
      sortable: false,
    },
    {
      name: 'From Date',
      selector: row => row?.fromDate ? moment.utc(row?.fromDate).format("MM-DD-YYYY") : "",
      sortable: false,
    },
    {
      name: 'To Date',
      selector: row => row?.toDate ? moment.utc(row?.toDate).format("MM-DD-YYYY") : "",
      sortable: false,
    },
    {
      name: 'Status',
      selector: row => row?.status ?? "",
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (props) =>
        subValDashboard?.edit?.display &&
        <div className="d-flex">
          <a
            className={`${subValDashboard?.edit?.enable === false ? 'pe-none' : ''} text-success action-button`}
            onClick={() => handleEdit(props)}
          >
            <i className="mdi mdi-pencil font-size-18"></i>
          </a>
          <a
            className={`${subValDashboard?.delete?.enable === false ? 'pe-none' : ''}  text-danger action-button`}
            onClick={() => handleDelete(props?.themeId)}
          >
            <i className="mdi mdi-delete font-size-18"></i>
          </a>
        </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];
  console.log("form", form)
  return (
    <div className="container mt-2 m-0 theme-wrapper">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h4 className="form-title">Special Days</h4>
        <button className="stroke-btn-style" onClick={toggleView}>
          {/* <span className="material-symbols-outlined" id="back-icon">arrow_back</span> */}
          {isListView ? "Add Special Day" : "Back to list"}
        </button>
      </div>

      {isListView ? (
        <DataTable
          id="categoriesTable"
          className="theme-table"
          key={keyForRerender}
          columns={columns}
          keyField="_id"
          data={Array.isArray(data) ? data : []}
          highlightOnHover
          fixedHeaderScrollHeight="300px"
          pagination
          responsive
          striped
          noDataComponent={customNoRecords()}
          paginationTotalRows={data.length}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          paginationPerPage={rowsPerPage}
          paginationDefaultPage={currentPageNew}
          paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
          paginationComponentOptions={{
            rowsPerPageText: 'Per page:',
            rangeSeparatorText: 'of',
            noRowsPerPage: false,
            selectAllRowsItem: false,
            selectAllRowsItemText: 'All',
          }}
          progressPending={isLoading}
          progressComponent={<TableLoader />}
        />

      ) : (
        <div className="row">
          <div className="col-md-6">
            {/* {['dayTitle', 'fromDate', 'toDate', 'status'].map((field) => (
              <div className="mb-3" key={field}>
                <label className="form_label">
                  {field === 'dayTitle' ? 'Day Title' : field === 'fromDate' ? 'From' : field === 'toDate' ? 'To' : 'Status'}
                </label>
                {field !== 'status' ? (
                  <input
                    type={field.includes('Date') ? 'date' : 'text'}
                    className={`form-control ${formErrors[field] ? 'is-invalid' : ''}`}
                    name={field}
                    value={form[field]}
                    onChange={handleChange}
                    placeholder={field === 'dayTitle' ? 'Enter day name' : ''}
                  />
                ) : (
                  <select
                    className={`form-select ${formErrors[field] ? 'is-invalid' : ''}`}
                    name={field}
                    value={form[field]}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                )}
                {formErrors[field] && <div className="invalid-feedback">{formErrors[field]}</div>}
              </div>
            ))} */}

            {/* {['dayTitle', 'fromDate', 'toDate', 'status'].map((field) => (
              <div className="mb-3" key={field}>
                <label className="form_label">
                  {field === 'dayTitle'
                    ? 'Day Title'
                    : field === 'fromDate'
                      ? 'From'
                      : field === 'toDate'
                        ? 'To'
                        : 'Status'}
                </label>

                {field !== 'status' ? (
                  <input
                    type={field.includes('Date') ? 'date' : 'text'}
                    className={`form-control ${formErrors[field] ? 'is-invalid' : ''}`}
                    name={field}
                    value={form[field]}
                    onChange={handleChange}
                    placeholder={field === 'dayTitle' ? 'Enter day name' : ''}
                    readOnly={field === 'dayTitle' && isEditMode}
                  />
                ) : (
                  <select
                    className={`form-select ${formErrors[field] ? 'is-invalid' : ''}`}
                    name={field}
                    value={form[field]}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="ACTIVE">ACTIVE</option>
                    <option value="INACTIVE">INACTIVE</option>
                  </select>
                )}

                {formErrors[field] && (
                  <div className="invalid-feedback">{formErrors[field]}</div>
                )}
              </div>
            ))} */}


            {['dayTitle', 'fromDate', 'toDate', 'status'].map((field) => (
              <div className="mb-3" key={field}>
                <label className="form_label">
                  {field === 'dayTitle'
                    ? 'Day Title'
                    : field === 'fromDate'
                      ? 'From'
                      : field === 'toDate'
                        ? 'To'
                        : 'Status'}
                </label>

                {field !== 'status' ? (
                  <input
                    type={field.includes('Date') ? 'date' : 'text'}
                    className={`form-control ${formErrors[field] ? 'is-invalid' : ''}`}
                    name={field}
                    value={form[field]}
                    onChange={handleChange}
                    placeholder={field === 'dayTitle' ? 'Enter day name' : ''}
                    readOnly={field === 'dayTitle' && isEditMode}
                    min={
                      field === 'fromDate'
                        ? (isEditMode ? form.fromDate : moment().format('YYYY-MM-DD'))
                        : field === 'toDate'
                          ? (form.fromDate ? form.fromDate : moment().format('YYYY-MM-DD'))
                          : undefined
                    }
                  />
                ) : (
                  <select
                    className={`form-select ${formErrors[field] ? 'is-invalid' : ''}`}
                    name={field}
                    value={form[field]}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="ACTIVE">ACTIVE</option>
                    <option value="INACTIVE">INACTIVE</option>
                  </select>
                )}

                {formErrors[field] && (
                  <div className="invalid-feedback">{formErrors[field]}</div>
                )}
              </div>
            ))}



            <div className="mt-3">

              <button
                id="saveThemeBtn"
                className="fill-btn-style"
                onClick={handleSave}
                disabled={btnLoader}
              >
                {btnLoader &&
                  <img
                    id="loadingIcon"
                    src={`${image}${appname}/images/web/rotate_right.svg`}
                    className="loading-icon me-2"
                    alt="Loading"
                  />
                }
                {isEditMode ? "Update" : "Save"}
              </button>
            </div>
          </div>

          <div className="col-md-6 d-flex flex-column align-items-center justify-content-start">
            <h5 className="form-title">Preview</h5>
            <img
              src={`${image}${appname}/images/web/${getThemeImage(form.theme)}`}
              className="theme-img mb-3"
              alt="Theme Preview"
              style={{ maxWidth: "150px", borderRadius: "8px" }}
            />
            <p className="sm-heading">Theme: {form.theme}</p>
            <button className="stroke-button" onClick={handleClick}>Select Theme</button>
          </div>

          <Modal
            show={show}
            onHide={() => setShow(false)}
            backdrop="static"
            centered
            className="theme-modal-wrapper"
          >
            <Modal.Header closeButton>
              <Modal.Title>SELECT THEME</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="theme-scroll-container d-flex flex-row flex-nowrap overflow-auto px-2">
                {[
                  "Default",
                  "Sunset Red",
                  "Ocean Blue",
                  "Calm Forest",
                  "Fire Red",
                  "Christmas",
                  "Halloween",
                  "New Year",
                  "Independence day"
                ].map((name) => (
                  <div
                    key={name}
                    className="theme-item text-center me-3"
                    style={{ minWidth: "180px" }}
                  >
                    <button
                      onClick={() => handleButtonClick(name)}
                      style={{
                        border:
                          selectedButton === name ? "2px solid #6f42c1" : "1px solid #dee2e6",
                        borderRadius: "8px",
                        padding: "4px",
                        background: "white",
                        width: "100%",
                      }}
                    >
                      <img
                        src={`${image}${appname}/theme/${getThemeImage(name)}`}
                        alt={name}
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: "4px",
                          objectFit: "cover",
                        }}
                      />
                    </button>
                    <h6 className="form-title mt-2">{name}</h6>
                  </div>
                ))}
              </div>
            </Modal.Body>

            <Modal.Footer className="justify-content-end">
              <button className="fill-btn-style" onClick={handleSet}>SET</button>
            </Modal.Footer>
          </Modal>


        </div>
      )}
      <Modal className="new-set-modal" show={isDelete} id="category-modal">
        <div className="modal-dialog modal-dialog-centered" id="category-modal-dialog">
          <div className="modal-content rounded-4" id="category-modal-content">

            {/* Modal Header */}
            <div className="modal-header border-0 justify-content-center position-relative" id="category-modal-header">
              <button className="close-btn" onClick={e => handleClose()} id="category-close-btn">
                <span className="material-icons">close</span>
              </button>
            </div>

            {/* Modal Body */}
            <div className="modal-body text-center" id="category-modal-body">
              <img
                src={`${image}${appname}/images/web/disco-ball.gif`}
                alt="Delete Icon"
                className=""
                style={{ width: "100px", height: "100px" }}
                id="category-delete-icon"
              />
              <h3 className="modal-sm-heading" id="category-modal-title">Delete</h3>
              <p className="modal-text" id="category-modal-text">
                The changes cannot be undone.<br />
                Do you want to delete?
              </p>
            </div>

            {/* Modal Footer */}
            <div className="modal-footer border-0 justify-content-center gap-3 pb-4" id="category-modal-footer">
              <button className="stroke-btn-style" onClick={handleCancel} id="category-cancel-btn">Don’t Delete</button>
              <button className="fill-btn save_continue" onClick={handleDeleteTheme} id="category-confirm-btn">
                {deleteLoader ? (
                  <img
                    src={`${image}${appname}/images/web/rotate_right.svg`}
                    className="loading-icon"
                    alt="Loading"
                    id="category-loader-icon"
                  />
                ) : null}
                Yes
              </button>
            </div>

          </div>
        </div>
      </Modal>
      <ToastContainer
        id="toastContainer"
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />
    </div>
  );
};

export default Theme;
